<nav class="bg-white z-20">
  <div class="mx-auto max-w-full px-6 lg:px-8">
    <div class="flex h-24 items-center">
      <div class="flex flex-1 items-center lg:justify-between">
        <button
          class="w-10 h-10 bg-white flex items-center justify-center rounded-lg shadow-xl shadow-primary-500/30 lg:hidden mr-6"
          (click)="appService.toggleMenu(); $event.stopPropagation()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
          >
            <path
              d="M1 13H17"
              stroke="#3D5CF5"
              stroke-width="1.6"
              stroke-linecap="round"
            />
            <path
              d="M1 9H17"
              stroke="#3D5CF5"
              stroke-width="1.6"
              stroke-linecap="round"
            />
            <path
              d="M1 5H17"
              stroke="#3D5CF5"
              stroke-width="1.6"
              stroke-linecap="round"
            />
          </svg>
        </button>
        <a
          routerLink="/"
          class="flex flex-shrink-0 items-center mr-auto lg:mr-0"
        >
          <img
            width="140"
            height="41"
            [ngSrc]="baseUrl + '/assets/imgs/logo.svg'"
            alt="Mobo"
            class="w-[120px] lg:w-[140px]"
            priority
          />
        </a>
        <div class="hidden lg:flex gap-3">
          <a
            routerLink="/cupons"
            routerLinkActive
            [routerLinkActiveOptions]="{ exact: true }"
            #rla1="routerLinkActive"
            [ngClass]="
              rla1.isActive
                ? 'text-primary-500'
                : 'text-slate-800 hover:bg-primary-500 hover:text-white '
            "
            class="rounded-md px-2 py-2 text-base font-semibold"
            aria-current="page"
            >Cupons</a
          >
          <a
            routerLink="/delivery"
            routerLinkActive
            [routerLinkActiveOptions]="{ exact: true }"
            #rla2="routerLinkActive"
            [ngClass]="
              rla2.isActive
                ? 'text-secondary-600'
                : 'text-slate-800 hover:bg-secondary-600 hover:text-white'
            "
            class="rounded-md px-2 py-2 text-base font-semibold italic flex items-center"
            aria-current="page"
            >Delivery
            <span
              class="text-xs bg-error-500 text-white rounded-3xl px-1 flex w-min h-min ml-2"
              >novo</span
            ></a
          >
          <a
            routerLink="/restaurantes"
            routerLinkActive
            [routerLinkActiveOptions]="{ exact: true }"
            #rla3="routerLinkActive"
            [ngClass]="
              rla3.isActive
                ? 'text-primary-500'
                : 'text-slate-800 hover:bg-primary-500 hover:text-white '
            "
            class="rounded-md px-2 py-2 text-base font-semibold"
            >Restaurantes</a
          >
          <a
            routerLink="/baixe-o-app"
            routerLinkActive
            [routerLinkActiveOptions]="{ exact: true }"
            #rla4="routerLinkActive"
            [ngClass]="
              rla4.isActive
                ? 'text-primary-500'
                : 'text-slate-800 hover:bg-primary-500 hover:text-white '
            "
            class="rounded-md px-2 py-2 text-base font-semibold"
            >Baixe o APP</a
          >
          <a
            routerLink="/planos"
            routerLinkActive
            [routerLinkActiveOptions]="{ exact: true }"
            #rla5="routerLinkActive"
            [ngClass]="
              rla5.isActive
                ? 'text-primary-500'
                : 'text-slate-800 hover:bg-primary-500 hover:text-white '
            "
            class="rounded-md px-2 py-2 text-base font-semibold"
            >Parceiro Mobo</a
          >
          <a
            href="https://backoffice.mobo.com.br/"
            target="_blank"
            rel="noopener noreferrer"
            class="rounded-md px-2 py-2 text-base font-semibold text-primary-500 ring-2 ring-primary-500 hover:bg-primary-500 hover:text-white"
            >Painel do Restaurante</a
          >
        </div>
        <ng-template [ngIf]="cities && cities[0]">
          <mobo-dropdown
            [options]="cities"
            value="id"
            description="name"
            label="Porto Alegre"
            [selectedValue]="selectedCity"
            (change)="changeCity($event)"
          ></mobo-dropdown>
        </ng-template>
      </div>
    </div>
  </div>
</nav>
